import { createTheme } from "@mui/material";
import { components, palette, typography } from "./components";

export const theme = createTheme({
  palette: {
    ...palette,
  },
  typography: {
    ...typography,
  },
  components: {
    ...components,
  },
});
